// @flow

import Service from './service';

export default class AuthService extends Service {
  token: string;
  tokenExp: Date;

  getToken(): Promise<string> {
    if (this.token && this.tokenExp.getTime() > (+new Date() + 1000)) {
      return Promise.resolve(this.token);
    }

    return this.api.get(`${this.baseUrl}/auth/token`)
      .then((res) => {
        const { data: { token, expires } } = res;
        this.token = token;
        this.tokenExp = new Date(expires);
        return token;
      });
  }

  pollAuth() {
    return this.api
      .put(`${this.baseUrl}/session/status`, {})
      .then(res => res.data && res.data.isAuthenticated)
      .catch(() => false);
  }

  refreshSession() {
    return this.api
      .put(`${this.baseUrl}/session/refresh`, {})
      .then(res => res.data && res.data.isAuthenticated)
      .catch(() => false);
  }
}
